import React, { useCallback, useState } from "react";
import { adminApi } from "../services/adminApi";
import StatCard from "../components/StatCard";
import usePolling from "../hooks/usePolling";

export default function Overview() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const next = await adminApi.getDashboard();
      setData(next);
      setError("");
    } catch (err) {
      setError(err?.response?.data?.error || "Failed to load dashboard");
    } finally {
      setLoading(false);
    }
  }, []);

  usePolling(load, 15000, []);

  if (loading) return <div>Loading overview...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!data) return null;

  const kpis = data.kpis || {};
  const logs = data.queues?.recentAuditLogs || [];
  const withdrawals = data.queues?.recentWithdrawals || [];

  return (
    <div>
      <h2>Overview Dashboard</h2>
      <p className="muted">Auto refresh every 15 seconds while tab is active.</p>
      <div className="stat-grid">
        <StatCard label="Total Users" value={kpis.totalUsers ?? 0} />
        <StatCard label="Total Deposits" value={(kpis.totalDeposits ?? 0).toFixed(2)} />
        <StatCard label="Total Withdrawals" value={(kpis.totalWithdrawals ?? 0).toFixed(2)} />
        <StatCard label="Total Trades" value={kpis.totalTrades ?? 0} />
        <StatCard label="Total Stakes" value={kpis.totalStakes ?? 0} />
        <StatCard label="Trade Earnings" value={(kpis.totalTradeEarnings ?? 0).toFixed(2)} />
        <StatCard label="Licenses Purchased" value={kpis.totalLicensesPurchased ?? 0} />
      </div>

      <div className="row" style={{ marginTop: 14 }}>
        <div className="card" style={{ flex: 1 }}>
          <h3>Recent Security Logs</h3>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Time</th>
                  <th>User</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => (
                  <tr key={log.id}>
                    <td>{new Date(log.createdAt).toLocaleString()}</td>
                    <td>{log.user?.email || "system"}</td>
                    <td>{log.action}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="card" style={{ flex: 1 }}>
          <h3>Recent Withdrawals</h3>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Time</th>
                  <th>User</th>
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {withdrawals.map((item) => (
                  <tr key={item.id}>
                    <td>{new Date(item.createdAt).toLocaleString()}</td>
                    <td>{item.user?.email || item.userId}</td>
                    <td>{item.amount}</td>
                    <td>{item.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
